/* eslint-disable @typescript-eslint/no-explicit-any */
import { buildSearchParams } from '@mercadoni/sinister/dist/cjs/shared'
import { useRouter } from 'next/navigation'

export const SEARCH_AGGREGATES = {
  orderBy: 'orderBy',
  priceRanges: 'priceRanges',
  tags: 'tags',
  availablePromotions: 'availablePromotions',
  categories: 'categories',
  brands: 'brands',
  isAvailable: 'isAvailable',
  sort: 'sort',
}

const useSearchCtrls = () => {
  const { push } = useRouter()

  const onClickSearch = ({ target }: { target: any }) => {
    const { name, filters } = target
    const searchParams = buildSearchParams({
      searchTerm: name,
      ...filters,
    }).toString()
    push(`/search?${searchParams.toString()}`)
  }

  return { onClickSearch }
}

export default useSearchCtrls
